import { useEffect, useState } from "react";
import api from "@/lib/api";
import MarketingShell from "@/components/MarketingShell";
import { Mail, Phone, MapPin, Clock, Linkedin, Twitter, Instagram } from "lucide-react";

export default function Contact() {
  const [content, setContent] = useState(null);
  useEffect(() => { api.get("/site-content").then(({ data }) => setContent(data)); }, []);
  const c = content?.contact;

  return (
    <MarketingShell content={content} current="contact">
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-16 pb-24 animate-fade-up">
        <span className="label-eyebrow text-mr-accent">Get in touch</span>
        <h1 className="font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-mr-primary mt-3">Contact MedRewards</h1>
        <p className="text-mr-secondary text-lg leading-relaxed mt-6 max-w-2xl">{c?.intro}</p>

        <div className="mt-12 grid sm:grid-cols-2 gap-6">
          {c?.email && (
            <a
              href={`mailto:${c.email}`}
              data-testid="contact-email-link"
              className="group bg-white border border-mr rounded-2xl p-6 flex items-start gap-4 hover:-translate-y-1 transition-all"
            >
              <div className="h-12 w-12 rounded-xl bg-[#E2E8F0] flex items-center justify-center"><Mail className="h-5 w-5 text-mr-accent" /></div>
              <div>
                <p className="label-eyebrow text-mr-secondary">Email</p>
                <p className="font-display text-lg font-semibold text-mr-primary group-hover:text-mr-accent transition-colors">{c.email}</p>
                <p className="text-mr-secondary text-sm mt-1">Click to send us a message</p>
              </div>
            </a>
          )}
          {c?.phone && (
            <a
              href={`tel:${c.phone.replace(/\s/g, "")}`}
              data-testid="contact-phone-link"
              className="group bg-white border border-mr rounded-2xl p-6 flex items-start gap-4 hover:-translate-y-1 transition-all"
            >
              <div className="h-12 w-12 rounded-xl bg-[#E2E8F0] flex items-center justify-center"><Phone className="h-5 w-5 text-mr-accent" /></div>
              <div>
                <p className="label-eyebrow text-mr-secondary">Phone</p>
                <p className="font-display text-lg font-semibold text-mr-primary group-hover:text-mr-accent transition-colors">{c.phone}</p>
              </div>
            </a>
          )}
          {c?.address && (
            <div className="bg-white border border-mr rounded-2xl p-6 flex items-start gap-4">
              <div className="h-12 w-12 rounded-xl bg-[#E2E8F0] flex items-center justify-center"><MapPin className="h-5 w-5 text-mr-accent" /></div>
              <div>
                <p className="label-eyebrow text-mr-secondary">Office</p>
                <p className="font-display text-lg font-semibold text-mr-primary">{c.address}</p>
              </div>
            </div>
          )}
          {c?.hours && (
            <div className="bg-white border border-mr rounded-2xl p-6 flex items-start gap-4">
              <div className="h-12 w-12 rounded-xl bg-[#E2E8F0] flex items-center justify-center"><Clock className="h-5 w-5 text-mr-accent" /></div>
              <div>
                <p className="label-eyebrow text-mr-secondary">Office hours</p>
                <p className="font-display text-lg font-semibold text-mr-primary">{c.hours}</p>
              </div>
            </div>
          )}
        </div>

        {(c?.linkedin || c?.twitter || c?.instagram) && (
          <div className="mt-10 flex items-center gap-3">
            <p className="label-eyebrow text-mr-secondary">Follow us</p>
            {c?.linkedin && <a data-testid="social-linkedin" href={c.linkedin} target="_blank" rel="noreferrer" className="h-10 w-10 rounded-full bg-white border border-mr flex items-center justify-center hover:bg-[#E2E8F0]"><Linkedin className="h-4 w-4 text-mr-primary" /></a>}
            {c?.twitter && <a data-testid="social-twitter" href={c.twitter} target="_blank" rel="noreferrer" className="h-10 w-10 rounded-full bg-white border border-mr flex items-center justify-center hover:bg-[#E2E8F0]"><Twitter className="h-4 w-4 text-mr-primary" /></a>}
            {c?.instagram && <a data-testid="social-instagram" href={c.instagram} target="_blank" rel="noreferrer" className="h-10 w-10 rounded-full bg-white border border-mr flex items-center justify-center hover:bg-[#E2E8F0]"><Instagram className="h-4 w-4 text-mr-primary" /></a>}
          </div>
        )}
      </section>
    </MarketingShell>
  );
}
